import { interpolateLinear } from '@nucleus/lib-number';
import { Fade } from '@nucleus/types/media/blending';
import { css } from 'styled-components';

const FadeToDegrees: Record<Fade, number> = {
  none: 0,
  top: 0,
  right: 90,
  bottom: 180,
  left: 270,
  topRight: 30,
  topLeft: 330,
  bottomRight: 150,
  bottomLeft: 210,
};

type Css = ReturnType<typeof css>;

export function buildFadeCss(color: string | undefined, fadeDirection: Fade | undefined, fadeIntensity = 0.5): Css {
  const { opacity, background } = buildFadeCssObject(color, fadeDirection, fadeIntensity);

  return css`
    opacity: ${opacity};
    background: ${background};
  `;
}

export function buildFadeCssObject(
  color: string | undefined,
  fadeDirection: Fade | undefined,
  fadeIntensity = 0.5
): { opacity: number; background: string } {
  if (color === undefined || fadeDirection === undefined || fadeDirection === 'none') {
    return { opacity: 0, background: 'transparent' };
  }

  const degrees = FadeToDegrees[fadeDirection];
  const [opacity, fadeStart, fadeEnd] = calculateFadeProperties(fadeIntensity);

  return {
    opacity: opacity / 100,
    background: `linear-gradient(${degrees}deg, transparent ${fadeStart}%, ${color} ${fadeEnd}%)`,
  };
}

export function calculateFadeProperties(fadeIntensity: number): [number, number, number] {
  const opacity = interpolateLinear(fadeIntensity, {
    from: { start: 0, end: 0.5 },
    to: { start: 0, end: 100 },
  });
  const fadeStart = interpolateLinear(fadeIntensity, {
    from: { start: 0.5, end: 1 },
    to: { start: 0, end: -100 },
  });
  const fadeEnd = interpolateLinear(fadeIntensity, {
    from: { start: 0, end: 1 },
    to: { start: 130, end: 70 },
  });

  return [opacity, fadeStart, fadeEnd];
}
